var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Grid from '@material-ui/core/Grid';
import React, { useReducer } from 'react';
import styled from 'styled-components';
/* @ts-ignore */
import SVG from 'react-inlinesvg';
import { Button, Chip } from '@kareo/design-system';
import { colorScale } from 'shared-assets/lib/colors';
import { GRID_SPACING, INPUT_MAX_LENGTH, } from 'shared-assets/components/PaymentCardForm';
import Form from 'shared-assets/components/Form';
import InputGroup from 'shared-assets/components/Form/InputGroup';
import Input from 'shared-assets/components/Elements/Input';
import Label from 'shared-assets/components/Elements/Label';
import LoadingOverlay from 'shared-assets/components/LoadingOverlay';
import ModalCard, { modalSize } from 'shared-assets/components/Modal/ModalCard';
import StateSelect from 'shared-assets/components/StateSelect';
import ActionsMenu from './ActionsMenu';
import PaymentCardContainer from '../CardOnFile/SavedCard/PaymentCardContainer';
var PaymentCardContainerStyled = styled(PaymentCardContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .actions {\n    display: grid;\n    place-items: center;\n  }\n"], ["\n  .actions {\n    display: grid;\n    place-items: center;\n  }\n"])));
var StyledSVG = styled(SVG)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-grid;\n  place-items: center;\n"], ["\n  display: inline-grid;\n  place-items: center;\n"])));
var AuthorizedLabel = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n"], ["\n  display: flex;\n  color: ", ";\n"])), colorScale.green_100);
var UnauthorizedLabel = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n\n  svg {\n    fill: ", ";\n  }\n"], ["\n  display: flex;\n  color: ", ";\n\n  svg {\n    fill: ", ";\n  }\n"])), colorScale.grey_50, colorScale.grey_50);
var formattedExpiration = function (month, year) {
    return "" + (month && String(month).length === 1 ? '0' : '') + month + "/" + year;
};
function reducer(state, action) {
    var _a;
    var value = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.value;
    switch (action.type) {
        case 'change-address-1':
            return __assign(__assign({}, state), { address1: value });
        case 'change-address-city':
            return __assign(__assign({}, state), { addressCity: value });
        case 'change-address-state':
            return __assign(__assign({}, state), { addressState: value });
        case 'change-address-zipcode':
            return __assign(__assign({}, state), { addressZipcode: value });
        case 'change-default-card':
            return __assign(__assign({}, state), { defaultCard: value });
        case 'change-expiration': {
            if (value.length === 2) {
                return __assign(__assign({}, state), { expiration: value + "/", expirationMonth: Number(value), expirationYear: null });
            }
            else if (value.length === 7) {
                var month = Number(value.slice(0, 2));
                var year = Number(value.slice(3, 7));
                return __assign(__assign({}, state), { expiration: formattedExpiration(month, year), expirationMonth: month, expirationYear: year });
            }
            else {
                return __assign(__assign({}, state), { expiration: value });
            }
        }
        case 'change-expiration-month':
            return __assign(__assign({}, state), { expirationMonth: value });
        case 'change-expiration-year':
            return __assign(__assign({}, state), { expirationYear: value });
        case 'change-name':
            return __assign(__assign({}, state), { name: value });
        case 'change-nickname':
            return __assign(__assign({}, state), { nickname: value });
        case 'change-note':
            return __assign(__assign({}, state), { note: value });
        case 'start-confirming-removal':
            return __assign(__assign({}, state), { confirmingRemoval: true });
        case 'stop-confirming-removal':
            return __assign(__assign({}, state), { confirmingRemoval: false });
        case 'start-editing':
            return __assign(__assign({}, state), { editing: true });
        case 'stop-editing':
            return __assign(__assign({}, state), { editing: false });
        case 'start-saving':
            return __assign(__assign({}, state), { saving: true });
        case 'stop-saving':
            return __assign(__assign({}, state), { saving: false });
        case 'start-removing':
            return __assign(__assign({}, state), { removing: true });
        case 'stop-removing':
            return __assign(__assign({}, state), { removing: false });
        case 'toggle-showing-details':
            return __assign(__assign({}, state), { showingDetails: !state.showingDetails });
        default:
            throw new Error();
    }
}
var SavedCard = function (props) {
    var initialState = __assign(__assign(__assign(__assign(__assign(__assign(__assign({ 
        // required state
        expirationMonth: props.expirationMonth, expirationYear: props.expirationYear, name: props.name }, (props.address1 && { address1: props.address1 })), (props.addressCity && { addressCity: props.addressCity })), (props.addressState && { addressState: props.addressState })), (props.addressZipcode && { addressZipcode: props.addressZipcode })), (props.nickname && { nickname: props.nickname })), (props.note && { note: props.note })), { 
        // lifecycle state
        confirmingRemoval: false, defaultCard: props.defaultCard, editing: false, removing: false, saving: false, showingDetails: false, 
        // expiration date state
        expiration: "" + (props.expirationMonth && String(props.expirationMonth).length === 1
            ? '0'
            : '') + props.expirationMonth + "/" + props.expirationYear });
    var _a = useReducer(reducer, initialState), state = _a[0], dispatch = _a[1];
    var onEdit = props.onEdit, onRemove = props.onRemove, onShowDetails = props.onShowDetails, onUpdate = props.onUpdate, _b = props.showSubmit, showSubmit = _b === void 0 ? true : _b, _c = props.authorizeButtonText, authorizeButtonText = _c === void 0 ? 'Authorize' : _c;
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var updateConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    dispatch({ type: 'start-saving' });
                    updateConfig = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (state.address1 && { address1: state.address1 })), (state.addressCity && { addressCity: state.addressCity })), (state.addressState && { addressState: state.addressState })), (state.addressZipcode && { addressZipcode: state.addressZipcode })), (state.nickname && { nickname: state.nickname })), (state.note && { note: state.note })), { defaultCard: state.defaultCard, expirationMonth: state.expirationMonth, expirationYear: state.expirationYear, name: state.name, paymentMethodId: props.paymentMethodId });
                    if (!onUpdate) return [3 /*break*/, 2];
                    return [4 /*yield*/, onUpdate(updateConfig)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    dispatch({ type: 'stop-saving' });
                    dispatch({ type: 'stop-editing' });
                    return [2 /*return*/];
            }
        });
    }); };
    var resetState = function () {
        // address1
        dispatch({
            type: 'change-address-1',
            payload: {
                value: props.address1,
            },
        });
        // addressCity
        dispatch({
            type: 'change-address-city',
            payload: {
                value: props.addressCity,
            },
        });
        // note
        dispatch({
            type: 'change-note',
            payload: {
                value: props.note,
            },
        });
        // nickname
        dispatch({
            type: 'change-nickname',
            payload: {
                value: props.nickname,
            },
        });
        // defaultCard
        dispatch({
            type: 'change-default-card',
            payload: {
                value: props.defaultCard,
            },
        });
        // expiration
        dispatch({
            type: 'change-expiration',
            payload: {
                value: formattedExpiration(props.expirationMonth, props.expirationYear),
            },
        });
        // expirationMonth
        dispatch({
            type: 'change-expiration-month',
            payload: {
                value: props.expirationMonth,
            },
        });
        // expirationYear
        dispatch({
            type: 'change-expiration-year',
            payload: {
                value: props.expirationYear,
            },
        });
        // name
        dispatch({
            type: 'change-name',
            payload: {
                value: props.name,
            },
        });
        // addressState
        dispatch({
            type: 'change-address-state',
            payload: {
                value: props.addressState,
            },
        });
        // addressZipcode
        dispatch({
            type: 'change-address-zipcode',
            payload: {
                value: props.addressZipcode,
            },
        });
    };
    var formId = "saved-card-" + props.paymentMethodId;
    return (React.createElement(LoadingOverlay, { isLoading: state.saving || state.removing },
        React.createElement(PaymentCardContainerStyled, null,
            React.createElement(Grid, { container: true, spacing: GRID_SPACING, justify: "space-between", wrap: "wrap" },
                React.createElement(Grid, { item: true, xs: "auto", style: { display: 'grid', placeItems: 'center' } },
                    React.createElement(Grid, { container: true, spacing: 1, alignItems: "center" },
                        React.createElement(Grid, { item: true },
                            React.createElement("img", { src: "/patient-intake-ui/image/" + props.type
                                    .replace(' ', '_')
                                    .toLowerCase() + ".png" })),
                        React.createElement(Grid, { item: true },
                            React.createElement("strong", null, props.nickname || props.type.toLocaleUpperCase())),
                        React.createElement(Grid, { item: true }, "-"),
                        React.createElement(Grid, { item: true }, props.last4),
                        React.createElement(Grid, { item: true },
                            ' ',
                            "(Exp ", props.expirationMonth + "/" + props.expirationYear,
                            ")"),
                        props.defaultCard && (React.createElement(Grid, { item: true },
                            React.createElement(Chip, { type: "active", label: "Default" }))))),
                React.createElement(Grid, { item: true, xs: "auto", style: { display: 'grid', placeItems: 'center' } },
                    React.createElement(Grid, { container: true, spacing: 1, alignItems: "center" },
                        !props.hideAuthStatus && (React.createElement(Grid, { item: true, xs: "auto" },
                            props.authorizedDate && (React.createElement(AuthorizedLabel, null,
                                React.createElement(StyledSVG, { cacheGetRequests: true, src: "/static/assets/icons/check-mark-alt.svg" }),
                                ' ',
                                "\u00A0 Authorized")),
                            !props.authorizedDate && (React.createElement(UnauthorizedLabel, null,
                                React.createElement(StyledSVG, { cacheGetRequests: true, src: "/static/assets/icons/info.svg" }),
                                ' ',
                                "\u00A0 Unauthorized")))),
                        React.createElement(Grid, { item: true },
                            React.createElement(ActionsMenu, { showingDetails: state.showingDetails, onEdit: function () {
                                    resetState();
                                    dispatch({ type: 'start-editing' });
                                    if (onEdit) {
                                        onEdit();
                                    }
                                }, onRemove: function () {
                                    resetState();
                                    dispatch({ type: 'stop-editing' });
                                    dispatch({ type: 'start-confirming-removal' });
                                }, onToggleDetails: function () {
                                    if (onShowDetails && !state.showingDetails) {
                                        onShowDetails();
                                    }
                                    dispatch({ type: 'toggle-showing-details' });
                                } }))))),
            state.showingDetails && (React.createElement(Grid, { container: true, spacing: GRID_SPACING },
                React.createElement(Grid, { item: true, xs: 3 }, "Name"),
                React.createElement(Grid, { item: true, xs: 9 }, props.name),
                React.createElement(Grid, { item: true, xs: 3 }, "Number"),
                React.createElement(Grid, { item: true, xs: 9 },
                    "Ending in ",
                    props.last4),
                React.createElement(Grid, { item: true, xs: 3 }, "Expiration Date"),
                React.createElement(Grid, { item: true, xs: 9 },
                    props.expirationMonth,
                    "/",
                    props.expirationYear),
                React.createElement(Grid, { item: true, xs: 3 }, "Billing Address"),
                React.createElement(Grid, { item: true, xs: 9 },
                    props.address1,
                    " ",
                    props.addressCity,
                    ", ",
                    props.addressState,
                    ' ',
                    props.addressZipcode),
                props.note && (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { item: true, xs: 3 }, "Note"),
                    React.createElement(Grid, { item: true, xs: 9 }, props.note)))))),
        state.editing && (React.createElement(ModalCard, { closeIcon: true, onClose: function () { return dispatch({ type: 'stop-editing' }); }, open: true, size: modalSize.extraLarge },
            React.createElement(Form, { id: formId, onSubmit: handleSubmit },
                React.createElement(Grid, { container: true, spacing: GRID_SPACING },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Grid, { container: true, spacing: GRID_SPACING },
                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                React.createElement(Label, null,
                                    "Cardholder Name",
                                    React.createElement(Input, { onChange: function (e) {
                                            return dispatch({
                                                type: 'change-name',
                                                payload: {
                                                    value: e.target.value,
                                                },
                                            });
                                        }, placeholder: "John Doe", required: true, maxLength: INPUT_MAX_LENGTH.cardHolder, value: state.name }))),
                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                React.createElement(Label, null,
                                    "Card Number",
                                    React.createElement(Input, { disabled: true, value: "**** **** **** " + props.last4 }))),
                            React.createElement(Grid, { item: true, xs: 6, md: 3 },
                                React.createElement(Label, null,
                                    "Expires",
                                    React.createElement(Input, { pattern: "[0-9]{2}/[0-9]{4}", placeholder: "MM/YYYY", required: true, value: state.expiration, onChange: function (event) {
                                            dispatch({
                                                type: 'change-expiration',
                                                payload: {
                                                    value: event.target.value,
                                                },
                                            });
                                        } }))),
                            React.createElement(Grid, { item: true, xs: 6, md: 3 },
                                React.createElement(Label, null,
                                    "CVC",
                                    React.createElement(Input, { placeholder: "***", disabled: true }))),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(Grid, { container: true, spacing: GRID_SPACING },
                                    React.createElement(Grid, { item: true, xs: 12, md: 4 },
                                        React.createElement(Label, null,
                                            "Billing Address",
                                            React.createElement(Input, { onChange: function (event) {
                                                    return dispatch({
                                                        type: 'change-address-1',
                                                        payload: {
                                                            value: event.target.value,
                                                        },
                                                    });
                                                }, placeholder: "1234 Street Name", required: !!props.addressRequired, maxLength: INPUT_MAX_LENGTH.address1, value: state.address1 }))),
                                    React.createElement(Grid, { item: true, xs: 6, md: 3 },
                                        React.createElement(Label, null,
                                            "City",
                                            React.createElement(Input, { onChange: function (event) {
                                                    return dispatch({
                                                        type: 'change-address-city',
                                                        payload: {
                                                            value: event.target.value,
                                                        },
                                                    });
                                                }, placeholder: "Springfield", required: !!props.addressRequired, maxLength: INPUT_MAX_LENGTH.city, value: state.addressCity }))),
                                    React.createElement(Grid, { item: true, xs: 6, md: 3 },
                                        React.createElement(Label, null,
                                            "State",
                                            React.createElement(StateSelect, __assign({ onChange: function (e) {
                                                    return dispatch({
                                                        type: 'change-address-state',
                                                        payload: {
                                                            value: e.target.value,
                                                        },
                                                    });
                                                } }, (state.addressState && {
                                                value: state.addressState,
                                            }))))),
                                    React.createElement(Grid, { item: true, xs: 12, md: 2 },
                                        React.createElement(Label, null,
                                            "Zip Code",
                                            React.createElement(Input, { onChange: function (event) {
                                                    return dispatch({
                                                        type: 'change-address-zipcode',
                                                        payload: {
                                                            value: event.target.value,
                                                        },
                                                    });
                                                }, placeholder: "00000", required: !!props.addressRequired, minLength: INPUT_MAX_LENGTH.zipcode, maxLength: INPUT_MAX_LENGTH.zipcode, value: state.addressZipcode }))))),
                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                React.createElement(Label, null,
                                    "Card Nickname (optional)",
                                    React.createElement(Input, { onChange: function (event) {
                                            return dispatch({
                                                type: 'change-nickname',
                                                payload: {
                                                    value: event.target.value,
                                                },
                                            });
                                        }, placeholder: "i.e. John Doe\u2019s HSA Card.", maxLength: INPUT_MAX_LENGTH.nickname, value: state.nickname }))),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(Label, null,
                                    "Comments/Instructions for Practice (optional)",
                                    React.createElement(Input, { onChange: function (event) {
                                            return dispatch({
                                                type: 'change-note',
                                                payload: {
                                                    value: event.target.value,
                                                },
                                            });
                                        }, placeholder: "i.e. Charge this card first.", maxLength: INPUT_MAX_LENGTH.note, value: state.note }))),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(InputGroup, { checked: state.defaultCard, disabled: props.defaultCard, onChange: function (evt) {
                                        dispatch({
                                            type: 'change-default-card',
                                            payload: {
                                                value: evt.target.checked,
                                            },
                                        });
                                    }, id: "make-default-card", type: "checkbox", name: "make-default-card", label: "Make this my default card" })),
                            showSubmit && (React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(Button, { color: "default", type: "submit" }, authorizeButtonText))))),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Grid, { container: true, spacing: GRID_SPACING, alignItems: "center", justify: "space-between" },
                            React.createElement(Grid, { item: true },
                                React.createElement(LoadingOverlay, { isLoading: state.saving },
                                    React.createElement(Button, { variant: "contained", color: "vitality", disabled: state.saving, type: "submit" }, "Save Card"),
                                    React.createElement(Button, { variant: "text", type: "button", onClick: function () {
                                            resetState();
                                            dispatch({ type: 'stop-editing' });
                                        }, style: { marginLeft: '1rem' } }, "Cancel"))),
                            React.createElement(Grid, { item: true },
                                React.createElement(Button, { variant: "text", type: "button", onClick: function () {
                                        resetState();
                                        dispatch({ type: 'stop-editing' });
                                        dispatch({ type: 'stop-confirming-removal' });
                                    } }, "Remove Card")))))))),
        state.confirmingRemoval && (React.createElement(ModalCard, { header: "Remove Credit Card", footer: React.createElement(LoadingOverlay, { isLoading: state.removing },
                React.createElement(Grid, { container: true, spacing: GRID_SPACING, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { color: "secondary", variant: "contained", type: "button", disabled: state.saving, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            dispatch({ type: 'start-removing' });
                                            if (!onRemove) return [3 /*break*/, 2];
                                            return [4 /*yield*/, onRemove(props)];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            dispatch({ type: 'stop-removing' });
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, "Confirm")),
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { variant: "text", disabled: state.saving, type: "button", onClick: function () {
                                resetState();
                                dispatch({ type: 'stop-confirming-removal' });
                            } }, "Cancel")))), closeIcon: true, onClose: function () { return dispatch({ type: 'stop-confirming-removal' }); }, open: true, size: modalSize.default }, "Are you sure you want to remove this card? This action cannot be reversed."))));
};
export default SavedCard;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
